import React from 'react';
import classnames from 'classnames';
import { formatCurrency } from 'Core/utils/numberFormat';

export const LEGACY_MONTHS_TO_PAY = 12;

export default function OfferOptionsHeader({ isPromo, checked, promoTerm, amountToPay }) {
  if (!isPromo) {
    return null;
  }
  const promoMonthsToPay = LEGACY_MONTHS_TO_PAY;

  const adjustedMonthlyPayment = amountToPay / promoMonthsToPay;
  return (
    <section
      className={classnames(
        'flex justify-between  px-2 py-4 items-center flex-wrap transition-colors duration-300',
        {
          'bg-gray-300': !isPromo && !checked,
          'bg-blue-200': !isPromo && checked,
          'bg-teal-200': isPromo && !checked,
          'bg-blue-600': isPromo && checked,
        }
      )}
    >
      {isPromo ? (
        <div
          className={classnames('text-sm px-2 flex-col-12 mt-3', {
            'text-teal-700': !checked,
            'text-white': checked,
          })}
        >
          <div>Waived interest if paid within {promoTerm} months</div>
          <div className="mt-2">
            {' '}
            <strong>{formatCurrency(adjustedMonthlyPayment, { withDecimals: true })}</strong> per
            month for {promoMonthsToPay} months{' '}
          </div>
        </div>
      ) : (
        <div className="text-sm text-gray-700 px-4 flex-col-12 mt-8">
          {/* {fixedTerm + ' mo'} Fixed term */}
        </div>
      )}
    </section>
  );
}
